// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.publisher-remaining-share-count {
  border-top: 1px solid #c4c4c4;
  text-align: center;
  padding-top: 2rem;
  padding-bottom: 2rem;
  font-size: 1.6rem;
  line-height: 6rem;
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/WorkScenes/Steps/PublishersSteps/PublishersStep/PublisherRemainingShareCount/index.scss"],"names":[],"mappings":"AAEA;EACE,6BAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AADF","sourcesContent":["@use '@Styles/variables';\n\n.publisher-remaining-share-count {\n  border-top: 1px solid variables.$greyColorForBorder;\n  text-align: center;\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n  font-size: 1.6rem;\n  line-height: 6rem;\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
